import type { ComponentPropsWithRef, PropsWithChildren } from 'react'
import * as NavigationMenu from '@radix-ui/react-navigation-menu'
import cn from 'classnames'
import styles from './Navbar.module.css'

function Navbar({ children, className, ...props }: PropsWithChildren<NavigationMenu.NavigationMenuProps>) {
  return (
    <NavigationMenu.Root className={cn(styles.navbar, className)} {...props}>
      {children}
    </NavigationMenu.Root>
  )
}

function List({ ref, className, ...props }: ComponentPropsWithRef<typeof NavigationMenu.List>) {
  return <NavigationMenu.List ref={ref} className={cn(styles.list, className)} {...props} />
}
List.displayName = 'Navbar.List'

function Item({ ref, className, ...props }: ComponentPropsWithRef<typeof NavigationMenu.Item>) {
  return <NavigationMenu.Item ref={ref} className={cn(styles.item, className)} {...props} />
}
Item.displayName = 'Navbar.Item'

function Content({ ref, className, ...props }: ComponentPropsWithRef<typeof NavigationMenu.Content>) {
  return <NavigationMenu.Content ref={ref} className={cn(styles.content, className)} {...props} />
}
Content.displayName = 'Navbar.Content'

export default Object.assign(Navbar, { List, Item, Content })
